import { LocalStorage } from './localStorage';

const STORAGE_KEY = 'aceleres.recent-reactions';
const MAX_RECENT_REACTIONS = 24;

function readRecentReactions() {
  try {
    const stored = LocalStorage.get(STORAGE_KEY);
    return Array.isArray(stored)
      ? stored.filter(reaction => typeof reaction === 'string' && reaction)
      : [];
  } catch {
    return [];
  }
}

export function getRecentReactions(availableReactions = null) {
  const recentReactions = readRecentReactions();
  if (!Array.isArray(availableReactions)) return recentReactions;

  const available = new Set(availableReactions);
  return recentReactions.filter(reaction => available.has(reaction));
}

export function rememberRecentReaction(reaction) {
  if (typeof reaction !== 'string' || !reaction) return readRecentReactions();

  const recentReactions = [
    reaction,
    ...readRecentReactions().filter(item => item !== reaction),
  ].slice(0, MAX_RECENT_REACTIONS);

  try {
    LocalStorage.set(STORAGE_KEY, recentReactions);
  } catch {
    // O histórico continua disponível durante a sessão mesmo se o navegador
    // bloquear o armazenamento local.
  }

  return recentReactions;
}
